import moment from 'moment';

export const formatDate = (dateNum, isDue = false) => {
  if (isDue) {
    return moment(dateNum).format('YYYY-MM-DD');
  } else {
    return moment(dateNum).format('YYYY-MM-DD HH:mm:ss');
  }
};

/**
 * 根据两个时间计算多少天
 * @param {*} to
 * @param {*} at
 * @returns
 */
export const totalDay = (at, to) => {
  // var at = moment(日期时间).format('YYYY-MM-DD');
  // var to = moment(日期时间).format('YYYY-MM-DD');
  return moment(to).diff(at, 'day');
};
